import { Controller } from "@hotwired/stimulus"
import { saveAttendanceStatus } from "../../pwa/offline_queue"
import { renderBadge, resolveOfflineStatus } from "../../pwa/attendance_badge"

// Connects to data-controller="attandances--status-sync"
export default class extends Controller {

  static values = {
    showedUpAt: String,
    leftAt: String,
    date: String
  }
  async connect() {
    if (navigator.onLine) {
      await saveAttendanceStatus({
        showed_up_at: this.showedUpAtValue || null,
        left_at: this.leftAtValue || null,
        date: this.dateValue
      })
    } else {
      await this.renderOfflineStatus()
    }
  }

  async renderOfflineStatus() {
    const status = await resolveOfflineStatus()
    renderBadge(status)
  }
}
